import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shouldEnableMedicalReserve } from '../../utils/user';
import { toggleDialog } from '../../store/control/duck';
import MedicalSavings from './MedicalSavings';

interface Intl {
  locale: string;
  formatMessage: (descriptor: { id: string }, values?: Record<string, string | number>) => string;
}
interface CampaignCode {
  text: string;
}
interface State {
  user: { userDetails?: { userType?: string; campaignCodes?: CampaignCode[] } };
  functions: { campaignCodes?: CampaignCode[] };
}

const MedicalSavingsContainer = ({ intl, history }: { intl: Intl; history?: { push: (path: string) => void } }) => {
  const user = useSelector((state: State) => state.user.userDetails);
  const teamCampaignCodes = useSelector((state: State) => state.functions.campaignCodes);
  const dispatch = useDispatch();
  // Same individual/team campaign gate as the existing home-page calculator entry.
  const enabled = !!history && user?.userType === 'Adviser' && shouldEnableMedicalReserve({ user, teamCampaignCodes });
  const openCalculator = () => {
    if (!enabled || !history) return;
    dispatch(toggleDialog('financialCharts', false));
    history.push('/new/medical-reserve');
  };
  return <MedicalSavings intl={intl} onOpenCalculator={enabled ? openCalculator : undefined} />;
};

export default MedicalSavingsContainer;
